import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PanelButtons from './PanelButtons';
import InfoBox from './InfoBox';
import { Chip } from '@material-ui/core';
import '../css/status.css';
import OrderView from './OrderView';
import OrderResent from './OrderResent';
import { getStatusResources } from '../hooks/order-status';
import { useImagePath } from '../hooks/paths';


const useStyles = makeStyles((theme) => ({

  containerPage: {
    width: "100vw",
    height: "100vh",
  },


  containerFlex: {
    width: "100%",
    //marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor: "red",
  },

  containerInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",
    padding: theme.spacing(2),
    //marginTop: "5vh",
    fontSize: "1.3rem",
    textAlign: "center",
    [theme.breakpoints.up('md')]: {
      width: "40%",
      padding: theme.spacing(2),
    },
  },

  imageStatusContainer: {
    position: 'relative',
    marginTop: theme.spacing(4),
    width: "20%"
  },
  imageStatus: {
    position: 'absolute',
    width: "100%",
    top: 0,
    left: 0,
    right: 0,
  },

  imageBackground: {
    width: "100%",
  },

  imageProgress: {
    width: "90%",
    height: "auto",
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.up('md')]: {
      width: "70%",

    },
  },

  textProgress: {
    width: "90%",
    height: "auto",
    [theme.breakpoints.up('md')]: {
      width: "70%",
    },
  },



  linkWarning: {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%",
    backgroundColor: theme.palette.background.grey,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: "0.5rem",
  },


  text: {
    margin: 0,
    padding: 0,
    textAlign: 'justify'
  },

  orderView: {
    display: 'flex',
    width: "100%",
    //marginTop: theme.spacing(1),
    //backgroundColor: 'blue',
  },

  spaceBottom: {
    display: 'flex',
    width: "100%",
    marginBottom: "10vh",
    //backgroundColor: 'blue',
  },

  subtitle: {
    width: "100%",
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
}));





export default function OrderStatus(props) {
  const classes = useStyles();
  //const [stat]


  const { store, orderRt, order, strings, onBack, onSend } = props;
  const statusRt = orderRt.status;

  const pathImage = useImagePath()
  let res = getStatusResources(order,orderRt,store,strings,pathImage); 

  const urlImage = res.status;
  const urlProgress = res.progress;
  const link = orderRt.link;
  const animation = res.animation;
  const isTraking = store.trakingOrder;
  const urlBackground = res.background; 

  const handlerBack = () => {
    onBack();
  }

  const handlerSend = () => {
    onSend();
  }


  return (
    <div className={classes.containerPage}>
      <div className={classes.containerFlex}>
        <div className={classes.containerInfo}>

          <div className={classes.subtitle}>
            <Chip size='small'
              label={order.type == "delivery" ?
                strings.delivery_label.toUpperCase() :
                strings.takeaway_label.toUpperCase()}
              variant="outlined"
              sx={{ border: 0, borderRadius: '4px', bgcolor: 'background.grey' }}
            />
          </div>

          <div className={classes.imageStatusContainer}>
            <img className={classes.imageBackground} src={urlBackground} alt={"checkout"} />
            {statusRt !== "DELIVERED" && statusRt !== "REJECTED"
              ? <img className={animation} src={urlImage} alt={"checkout"} />
              : <img className={classes.imageStatus} src={urlImage} alt={"checkout"} />
            }
          </div>
          {/*  { <Typography variant ='body1' className={classes.text}>{roderNumber}</Typography> } */}

          {isTraking && statusRt !== "REJECTED" ?
            <img className={classes.imageProgress} src={urlProgress} alt={"progress"} />
            : ""
          }

          <div className={classes.textProgress}>
            <InfoBox
              message={res.message}
            />
          </div>

          <div className={classes.orderView} >
            <OrderView
              order={order}
              orderRt={orderRt}
              store={store}
              strings={strings}
            />
          </div>

          {res.warning &&
            <OrderResent
              phone={store.phone}
              link={link}
              message={res.warning}
              strings={strings}
            />
          }

          <div className={classes.spaceBottom}>
          </div>

        </div>
      </div>

      <PanelButtons
        labelCancel={strings.action_done}
        labelNext={res.warning ? strings.action_send_to_whatsapp : undefined}
        onClickCancel={handlerBack}
        onClickNext={handlerSend}
      />

    </div>
  );
}
